/* import __COLOCATED_TEMPLATE__ from './categories-and-latest-topics.hbs'; */
import Component from "@ember/component";
export default Component.extend({
  classNames: ["categories-and-latest"],
});
